export interface IPptComponentPosition {
	x: number;
	y: number;
	w: number;
	h?: number;
}

export abstract class AbstractPptComponent {
	protected position: IPptComponentPosition;

	protected constructor(position: IPptComponentPosition) {
		this.position = position;
	}

	protected abstract getHeight(): number;

	public getDimensionRect(): { bottom: number; w: number; x: number; h: number; y: number } {
		return {
			x: this.position.x,
			y: this.position.y,
			w: this.position.w,
			h: this.getHeight(),
			bottom: this.position.y + this.getHeight()
		};
	}
}
